module.exports = __webpack_public_path__ + "e04db6afba742df1cec68542db20d655.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/wff-icn-clr.png
// module id = 1774
// module chunks = 0